(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["announcement-bar"]) return;
  try {
    
if(!customElements.get('st-sale-countdown'))customElements.define('st-sale-countdown',class extends HTMLElement{
connectedCallback(){const deadline=Date.parse(this.dataset.deadline),output=this.querySelector('[data-countdown-output]');const update=()=>{const remaining=Math.max(0,Math.floor((deadline-Date.now())/1000));if(!Number.isFinite(deadline)||remaining===0){this.textContent=this.dataset.expired;clearInterval(this.interval);return;}const pad=n=>String(n).padStart(2,'0');output.textContent=Math.floor(remaining/86400)+'d '+pad(Math.floor(remaining/3600)%24)+'h '+pad(Math.floor(remaining/60)%60)+'m '+pad(remaining%60)+'s';};this.interval=setInterval(update,1000);update();}
disconnectedCallback(){clearInterval(this.interval);}
});

if(!customElements.get('st-holiday-invitation'))customElements.define('st-holiday-invitation',class extends HTMLElement{
connectedCallback(){
const dialog=this.querySelector('dialog'),deadline=Date.parse(this.dataset.deadline),key='st-holiday-invitation-2026-10-21';
if(!Number.isFinite(deadline)||Date.now()>=deadline)return;
let seen=false;try{seen=localStorage.getItem(key)==='seen';}catch(e){}
const close=()=>dialog.close();
this.querySelector('.st-holiday-close').addEventListener('click',close);
this.querySelector('.st-holiday-shop').addEventListener('click',close);
dialog.addEventListener('click',e=>{if(e.target===dialog){const r=dialog.getBoundingClientRect();if(e.clientX<r.left||e.clientX>r.right||e.clientY<r.top||e.clientY>r.bottom)close();}});
if(!seen){this.delay=setTimeout(()=>{if(!this.isConnected||Date.now()>=deadline)return;dialog.showModal();try{localStorage.setItem(key,'seen');}catch(e){}},1000);}
this.expiry=setTimeout(()=>{if(dialog.open)dialog.close();},Math.min(Math.max(0,deadline-Date.now()),2147483647));
}
disconnectedCallback(){clearTimeout(this.delay);clearTimeout(this.expiry);}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["footer"]) return;
  try {
    
  class LocalizationForm extends HTMLElement {
    constructor() {
      super();
      this.elements = {
        input: this.querySelector('input[name="locale_code"], input[name="country_code"]'),
        button: this.querySelector('button'),
        panel: this.querySelector('.disclosure__list-wrapper'),
      };
      this.elements.button.addEventListener('click', this.openSelector.bind(this));
      this.elements.button.addEventListener('focusout', this.closeSelector.bind(this));
      this.addEventListener('keyup', this.onContainerKeyUp.bind(this));

      this.querySelectorAll('a').forEach(item => item.addEventListener('click', this.onItemClick.bind(this)));
    }

    hidePanel() {
      this.elements.button.setAttribute('aria-expanded', 'false');
      this.elements.panel.setAttribute('hidden', true);
    }

    onContainerKeyUp(event) {
      if (event.code.toUpperCase() !== 'ESCAPE') return;

      this.hidePanel();
      this.elements.button.focus();
    }

    onItemClick(event) {
      event.preventDefault();
      const form = this.querySelector('form');
      this.elements.input.value = event.currentTarget.dataset.value;
      if (form) form.submit();
    }

    openSelector() {
      this.elements.button.focus();
      this.elements.panel.toggleAttribute('hidden');
      this.elements.button.setAttribute('aria-expanded', (this.elements.button.getAttribute('aria-expanded') === 'false').toString());
    }

    closeSelector(event) {
      const shouldClose = event.relatedTarget && event.relatedTarget.nodeName === 'BUTTON';
      if (event.relatedTarget === null || shouldClose) {
        this.hidePanel();
      }
    }
  }

  customElements.define('localization-form', LocalizationForm);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close());
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["satintheory-media-gallery"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('st-media-gallery'))customElements.define('st-media-gallery',class extends HTMLElement{
 connectedCallback(){
  const track=this.querySelector('.st-media-track'),buttons=this.querySelectorAll('[data-media-direction]');
  const update=()=>{buttons[0].disabled=track.scrollLeft<=1;buttons[1].disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
  buttons.forEach(button=>button.addEventListener('click',()=>track.scrollBy({left:Number(button.dataset.mediaDirection)*(track.querySelector('.st-media-card').getBoundingClientRect().width+parseFloat(getComputedStyle(track).gap)),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'})));
  track.addEventListener('scroll',update,{passive:true});this.resizeObserver=new ResizeObserver(update);this.resizeObserver.observe(track);update();
  this.querySelectorAll('video').forEach(video=>video.addEventListener('play',()=>this.querySelectorAll('video').forEach(other=>{if(other!==video)other.pause();})));
  this.visibilityObserver=new IntersectionObserver(entries=>entries.forEach(entry=>{if(!entry.isIntersecting)entry.target.pause();}),{threshold:.15});this.querySelectorAll('video').forEach(v=>this.visibilityObserver.observe(v));
 }
 disconnectedCallback(){this.resizeObserver?.disconnect();this.visibilityObserver?.disconnect();}
});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["satintheory-size-guide"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('st-size-guide')) {
  customElements.define('st-size-guide',class extends HTMLElement {
    connectedCallback() {
      this.dialog=this.querySelector('dialog');
      this.openHandler=(event)=>{
        const trigger=event.target.closest('[data-st-size-open],a[href="#st-size-guide"]');
        if(!trigger)return;
        event.preventDefault();this.opener=trigger;this.previousOverflow=document.body.style.overflow;
        this.dialog.showModal();document.body.style.overflow='hidden';
        this.querySelector('[data-size-close]').focus();
      };
      document.addEventListener('click',this.openHandler);
      this.querySelector('[data-size-close]').addEventListener('click',()=>this.dialog.close());
      this.dialog.addEventListener('click',(event)=>{if(event.target===this.dialog){const r=this.dialog.getBoundingClientRect();if(event.clientX<r.left||event.clientX>r.right||event.clientY<r.top||event.clientY>r.bottom)this.dialog.close();}});
      this.dialog.addEventListener('close',()=>{document.body.style.overflow=this.previousOverflow||'';if(this.opener&&this.opener.isConnected)this.opener.focus();});
      this.querySelectorAll('[data-size-unit]').forEach(button=>button.addEventListener('click',()=>{
        const unit=button.dataset.sizeUnit;
        this.querySelectorAll('[data-size-unit]').forEach(b=>b.setAttribute('aria-pressed',String(b===button)));
        this.querySelectorAll('[data-cm]').forEach(cell=>{cell.textContent=unit==='in'?(Number(cell.dataset.cm)/2.54).toFixed(1):cell.dataset.cm;});
      }));
    }
    disconnectedCallback(){document.removeEventListener('click',this.openHandler);if(this.dialog.open)document.body.style.overflow=this.previousOverflow||'';}
  });
}

  } catch(e) { console.error(e); }
})();
})();
